import React, { useState, lazy } from 'react';
import { PlayIcon } from 'lucide-react';
interface LazyYouTubeEmbedProps {
  videoId: string;
  title: string;
}
export function LazyYouTubeEmbed({
  videoId,
  title
}: LazyYouTubeEmbedProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const thumbnailUrl = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;
  if (!isLoaded) {
    return <button onClick={() => setIsLoaded(true)} className="relative w-full h-full group cursor-pointer" aria-label={`Play video: ${title}`} data-id="element-211">
        {/* Thumbnail */}
        <img src={thumbnailUrl} alt={title} className="w-full h-full object-cover" loading="lazy" data-id="element-212" />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors flex items-center justify-center" data-id="element-213">
          <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-214">
            <PlayIcon className="w-8 h-8 text-white ml-1" fill="white" data-id="element-215" />
          </div>
        </div>
      </button>;
  }
  return <iframe src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-216" />;
}